import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DetailViewComponent } from '../../detail-view.component';
import { DetailViewFormValidator } from '../../form-validator/detail-view-form-validator';
import { DetailViewNotifyService } from '../../shared/detailview-notify.service';
import { BaseControlComponent } from '../base-control/base-control.component';
import {FloatCalcFixDecimalPipe} from "../../../../shared/pipes/float-calculate.pipe";
import { takeUntil } from 'rxjs/operators';

// text,email,tel,textarea,password,
@Component({
    selector: 'text-box',
    templateUrl: './text-box.component.html',
    styleUrls: ['./text-box.component.scss'],
    standalone: false
})
export class TextBoxComponent extends BaseControlComponent implements OnInit, OnDestroy {
  @ViewChild('inputFieldRef', { static: true }) inputFieldRef: ElementRef;
  @ViewChild('inputAreaRef', { static: true }) inputAreaRef: ElementRef;

  public inputValue: any;

  constructor(
    public detailViewNotifyService: DetailViewNotifyService,
    public translate: TranslateService,
    public detailViewComponent: DetailViewComponent,
  ) {
    super(detailViewNotifyService, translate);
  }

  ngOnInit() {
    super.ngOnInit();

    // check if attribute value is float than convert to decimal number
    if (this.prop.field_float !== null) {
      // round floating points from coordinates for UI
      this.inputValue = this.roundFloating(this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name]);
      this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name] = this.inputValue;
      this.setInitialValue();
    } else {
      this.inputValue = this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name];
    }

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onChangeLineNummber(event): void {
    if (this.prop.field_name === 'LINIE') {
      this.detailViewNotifyService.onChangeVerkaufsObjectLinieNrSubject.next((event.target.value));
    }
  }

  protected specificValidateField() {
    if (this.formField.errors?.invalidMaxLength) {
      // Initial invalid message
      this.translate.get('DETAIL_VIEW.FORM_VALIDATION.MAX_LENGTH').pipe(takeUntil(this.unsubscribe$)).subscribe(msg => {
        this.errorMessages.push(`${msg} ${this.prop.max_length}`);
        // stop validation if fail
        return;
      });
    }

    if (this.formField.errors?.invalidMinLength) {
      // Initial invalid message
      this.translate.get('DETAIL_VIEW.FORM_VALIDATION.MIN_LENGTH').pipe(takeUntil(this.unsubscribe$)).subscribe(msg => {
        this.errorMessages.push(`${msg} ${this.prop.min_length}`);
        // stop validation if fail
        return;
      });
    }

    // PLZ invalid
    if (this.formField.errors?.invalidPLZ) {
      // Initial invalid message
      this.translate.get('DETAIL_VIEW.FORM_VALIDATION.PLZ').pipe(takeUntil(this.unsubscribe$)).subscribe(msg => {
        this.errorMessages.push(msg);
      });
    }

    // Year invalid
    if (this.formField.errors?.invalidYear) {
      this.translate.get('DETAIL_VIEW.FORM_VALIDATION.YEAR').pipe(takeUntil(this.unsubscribe$)).subscribe(msg => {
        this.errorMessages.push(msg);
      });
    }
  }

  /* Private methods
   =================== */

  protected initValidators(prop): Array<any> {
    // compose validators
    const validators = super.initValidators(prop);

    if (prop.max_length) {
      validators.push(DetailViewFormValidator.validateMaxLength(prop.max_length));
    }

    if (prop.min_length) {
      validators.push(DetailViewFormValidator.validateMinLength(prop.min_length));
    }

    // Validation for Prop = field_type - examples for the config: "type": "plz" or "type": "year"
    if (prop.field_type === 'plz') {
      validators.push(DetailViewFormValidator.validatePLZ);
    }

    if (prop.field_type === 'year') {
      validators.push(DetailViewFormValidator.validateYear);
    }

    return validators;
  }

  /**
   * @description rounds decimal numbers based on the given decimal points.
   */
  private roundFloating(value): string {
    const floatCalcFixDecimalPipe = new FloatCalcFixDecimalPipe();
    const isInteger: boolean = this.prop.field_float === 0;
    return floatCalcFixDecimalPipe.transform(value, this.prop.field_float, isInteger);
  }
}
